
export type TaskFrequency = 'none' | 'daily' | 'weekly' | 'monthly' | 'irregular'

export const FREQUENCY_LABELS: Record<TaskFrequency, string> = {
  none: 'なし',
  daily: '毎日',
  weekly: '毎週',
  monthly: '毎月',
  irregular: '不定期',
}

export type Task = {
  id: number
  title: string
  frequency: TaskFrequency
  repeat_on: number[]
  start_date: string | null
  due_date: string | null
  due_time: string | null
  repeat_end_date: string | null
  scheduled_time: string | null
  intensity_value: number | null
  intensity_unit: string
  tags: string[]
  rating: number
  is_completed: boolean
  completion_count: number
  last_completed_at: string | null
  next_scheduled_at: string | null
  is_completable: boolean
  created_at: string
}

export type OpenBadge = {
  id: number
  achievement: number | null
  badge_url: string
  badge_name: string
  issuer_name: string
  badge_image_url: string
  issued_on: string | null
  created_at: string
}

export type BadgePreview = {
  badge_name: string
  issuer_name: string
  badge_image_url: string
  issued_on: string | null
}

export type Achievement = {
  id: number
  task: number | null
  suggestion: number | null
  title: string
  score: string
  rating: number
  is_public: boolean
  memo: string
  tags: string[]
  earned_points: number
  status_gain: Record<string, number>
  achieved_at: string
  created_at: string
  open_badges: OpenBadge[]
  ai_tags: string[]
  ai_rating: number | null
  is_ai_analyzed: boolean
  // 実績の出所。'manual'=手動、'claude'等=MCP経由で接続したサービス（DCR名から自動導出）。
  source: string
}

export type AchievementSuggestion = {
  id: number | null
  title: string
  tags: string[]
  score_units: string[]
  source: 'master' | 'user' | 'history'
  created_at: string | null
}

export type Tag = {
  id: number
  name: string
  category: string
}
